import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable, of } from "rxjs";
import { environment } from '../../../environments/environment';
import { FinDeNavCbemDto } from "../../Models/CBEM";
import { ClientNav, ProductGroup } from "../../Models/Client-Nav";

@Injectable({
  providedIn: "root",
})
export class ClientDashboardService {
  // Service logic goes here
  private apiUrl = environment.apiUrl;
  private useLocalSampleData = true;

  constructor(private http:HttpClient) {

  } 

  getClient_by_id(id : string): Observable<ClientNav> {
    if (false) {
      return this.getClient_by_id_local(id);
    }
    return this.http.get<ClientNav>(`${this.apiUrl}/get-client-by-id/${id}`);
  }

  // Full replacement (PUT) of a client record
  updateClientInfo(id: string, full: ClientNav, userId: string): Observable<ClientNav> {
    if (false) {
      // Simulate immediate success when using local sample data
      return of(full);
    }
    return this.http.put<ClientNav>(`${this.apiUrl}/update-client/${id}`, {newClientInfo:full,userId: userId},
      {headers: {'Content-Type': 'application/json'}}
    );
  }

  // New: load local sample clients JSON and return matching client
  getClient_by_id_local(id: string): Observable<ClientNav> {
    return new Observable<ClientNav>((subscriber) => {
      this.http.get<{ clients: ClientNav[] }>('/assets/sample-clients.json').subscribe({
        next: (data) => {
          // try to match by clientId, s111ClientKey, or client name
          const found = data.clients.find(c => c.id === id);
          if (found) {
            subscriber.next(found as ClientNav);
            subscriber.complete();
          } else {
            subscriber.error(new Error('Client not found in local sample data'));
          }
        },
        error: (err) => subscriber.error(err)
      });
    });
  }

  // Export individual client data
  getPresignedUrl(clientId: string): Observable<{downloadURL: string}> {
    return this.http.get<{downloadURL: string}>(`${this.apiUrl}/export-client-data/${clientId}`);
  }

  getAllProductGroups(): Observable<ProductGroup[]> {
    return this.http.get<ProductGroup[]>(`${this.apiUrl}/get-all-product-groups`);
  }

  // Update only product groups for a client
  updateProductGroups(clientId: string, updatedProductGroups : ProductGroup[], userId: string): Observable<ProductGroup[]> {
    return this.http.put<ProductGroup[]>(`${this.apiUrl}/update-product-groups/${clientId}`, {newProductGroups: updatedProductGroups, userId: userId},
      {headers: {'Content-Type': 'application/json'}}
    );
  }

  // Persist per-product SSO federation for a product group
  updateSsoFederation(
    clientId: string,
    groupId: string,
    products: { productId: string; federation: Record<string, string> | null }[],
    userId: string,
  ): Observable<ProductGroup[]> {
    return this.http.put<ProductGroup[]>(`${this.apiUrl}/update-sso-federation/${clientId}`, { groupId, products, userId },
      {headers: {'Content-Type': 'application/json'}}
    );
  }

  getFormOptions(): Observable<Record<string, any[]>> {
    return this.http.get<Record<string, any[]>>(`${this.apiUrl}/get-form-options`);
  }

  getClientProductGroups(clientId: string): Observable<ProductGroup[]> {
    return this.http.get<ProductGroup[]>(`${this.apiUrl}/get-client-product-groups/${clientId}`);
  }
}